import { render, staticRenderFns } from "./localeSelect.vue?vue&type=template&id=3d4f3623"
import script from "./localeSelect.vue?vue&type=script&lang=js"
export * from "./localeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports